import React, {
  ComponentRef,
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';

import { Modal } from 'shared/presentation/components/atoms';
import { Button } from 'shared/presentation/components/molecules';
import { ICONS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';
import { useMediaQuery } from 'shared/presentation/hooks';

import * as S from './styles';
import { SecurityInfoCard } from '../../atoms';

interface ISecurityInfoModalRef {
  open(): void;
}

const SecurityInfoModal: React.ForwardRefRenderFunction<
  ISecurityInfoModalRef
> = (props, ref) => {
  const { t } = useLocale('authentication');
  const isMobile = useMediaQuery('md');

  const modalRef = useRef<ComponentRef<typeof Modal>>(null);

  useImperativeHandle(
    ref,
    () => ({ open: () => modalRef.current?.open() }),
    [],
  );

  return (
    <Modal ref={modalRef} align={isMobile ? 'bottom' : 'center'}>
      <S.Container>
        <header>
          <h2>{t('Doubts?')}</h2>
          <p>
            {t('Here is some important information about password recovery')}
          </p>
        </header>

        <section>
          <div>
            <SecurityInfoCard
              title={t('Your data is protected')}
              description={t(
                'No one at Vialaser will have access to your new password',
              )}
              icon={<ICONS.CHECK_CIRCLE />}
            />
            <SecurityInfoCard
              title={t('Valid code')}
              description={t(
                'The verification code is valid for {{time}} minutes',
              )}
              icon={<ICONS.COUNTER_CLOCK />}
            />
            <SecurityInfoCard
              title={t("Don't share your code")}
              description={t(
                'Never share your verification code with third parties',
              )}
            />
            <SecurityInfoCard
              title={t('Need help?')}
              description={t('Contact our support team')}
              icon={<ICONS.PHONE />}
            />
          </div>
        </section>

        <footer>
          <Button
            type="button"
            variant="primary"
            icon={ICONS.USER}
            iconPosition="right"
            onClick={() => {
              modalRef.current?.close();
            }}
          >
            {t('Go to login')}
          </Button>
        </footer>
      </S.Container>
    </Modal>
  );
};

export default forwardRef(SecurityInfoModal);
